import React from 'react'
import ReactDOM from 'react-dom/client'
import {BrowserRouter} from 'react-router-dom'
// import {ConfigProvider} from 'antd'
// import moment from 'moment'
// import zhCN from 'antd/es/locale/zh_CN'
import '@/assets/styles/index.less'
import {UserInfoProvider} from '@/store/userInfo'
import RouterEnter from '@/router/RouterEnter'
import Router from '@/router'
// import 'moment/locale/zh-cn'

window.AOS.init({
  once: false,
  duration: 1000
})

// moment.locale('zh-cn')

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  // <React.StrictMode>
    // <ConfigProvider locale={zhCN}>
      <UserInfoProvider>
        <BrowserRouter>
          <RouterEnter>
            <Router />
          </RouterEnter>
        </BrowserRouter>
      </UserInfoProvider>
    // </ConfigProvider>
  // </React.StrictMode>
);
